import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead,
    DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type OrderPrescripteurs = CollectionOpenSearchJsonldOpensearchCollectionPrescripteurRead &
    Record<string, unknown>;

const useOrderPrescriber = () => {
    const { collectionOpenSearchApi } = useFormaliteService();
    let searchValideurTimeout: number | undefined;

    const searchOrderPrescriber = (term: string): Promise<Array<OrderPrescripteurs>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchValideurTimeout);
            const requestParameters: DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest =
                { q: term };

            searchValideurTimeout = setTimeout(() => {
                collectionOpenSearchApi
                    .apiOpensearchCollectionsPrescripteursGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<OrderPrescripteurs>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchOrderPrescriber };
};

export default useOrderPrescriber;
